


























import { Component, Vue } from "vue-property-decorator";
import { ConfigModule } from "@/store/modules/config";
import { ErrorLogModule } from "@/store/modules/error-log";

@Component
export default class TheSettingsList extends Vue {
  set debug(bo: boolean) {
    ConfigModule.setDebug(bo);
  }

  get debug() {
    return ConfigModule.debug;
  }

  toggle() {
    this.darkMode = !this.darkMode;
  }

  reportBug() {
    const mailText = "mailto:support@mmmint.ai?subject=Fehlermeldung&body=";
    window.location.href = mailText;
  }

  set darkMode(bo: boolean) {
    ConfigModule.setDarkMode(bo);
  }

  get darkMode() {
    return ConfigModule.darkMode;
  }

  generateError() {
    ErrorLogModule.addErrorLog({
      name: "name",
      message: "message"
    });
  }
}
